import { setComponentMapOverrides } from '@jutro/uiconfig';

import { SgWizardPageTemplate } from 'saga-modules';

import SgEndorsementEntryPage from './pages/SgEndorsementEntryPage/SgEndorsementEntryPage';
import SgEndorsementVehiclePage from './pages/SgEndorsementVehiclePage/SgEndorsementVehiclePage';
import SgEndorsementDriverPage from './pages/SgEndorsementDriverPage/SgEndorsementDriverPage';
import SgEndorsementQuotePage from './pages/SgEndorsementQuotePage/SgEndorsementQuotePage';
import SgEndorsementCoveragesPage from './pages/SgEndorsementCoveragesPage/SgEndorsementCoveragesPage';
import SgEndorsementDeclarationsPage from './pages/SgEndorsementDeclarationsPage/SgEndorsementDeclarationsPage';
import SgEndorsementPaymentPage from './pages/SgEndorsementPaymentPage/SgEndorsementPaymentPage';
import SgEndorsementConfirmationPage from './pages/SgEndorsementConfirmationPage/SgEndorsementConfirmationPage';

setComponentMapOverrides(
    {
        SgEndorsementEntryPage: { component: 'SgEndorsementEntryPage' },
        SgEndorsementVehiclePage: { component: 'SgEndorsementVehiclePage' },
        SgEndorsementDriverPage: { component: 'SgEndorsementDriverPage' },
        SgEndorsementQuotePage: { component: 'SgEndorsementQuotePage' },
        SgEndorsementCoveragesPage: { component: 'SgEndorsementCoveragesPage' },
        SgEndorsementDeclarationsPage: { component: 'SgEndorsementDeclarationsPage' },
        SgEndorsementPaymentPage: { component: 'SgEndorsementPaymentPage' },
        SgEndorsementConfirmationPage: { component: 'SgEndorsementConfirmationPage' }
    },
    {
        SgEndorsementVehiclePage,
        SgEndorsementEntryPage,
        SgEndorsementDriverPage,
        SgEndorsementQuotePage,
        SgEndorsementCoveragesPage: SgEndorsementCoveragesPage,
        SgEndorsementDeclarationsPage,
        SgWizardPageTemplate,
        SgEndorsementPaymentPage,
        SgEndorsementConfirmationPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as EndorsementWizard } from './SgEndorsementWizard';
